<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.25 1.88h-1.22V.94a.94.94 0 10-1.87 0v.94h-4.27V.94a.94.94 0 10-1.87 0v.94H6.8V.94a.94.94 0 10-1.88 0v.94H3.75A3.75 3.75 0 000 5.63v14.62A3.75 3.75 0 003.75 24h7.17a.94.94 0 100-1.88H3.75a1.88 1.88 0 01-1.88-1.87V5.62c0-1.03.85-1.87 1.88-1.87h1.17v.94a.94.94 0 101.88 0v-.94h4.22v.94a.94.94 0 101.87 0v-.94h4.27v.94a.94.94 0 001.87 0v-.94h1.22c1.03 0 1.88.84 1.88 1.88v5.34a.94.94 0 001.87 0V5.62a3.75 3.75 0 00-3.75-3.75zm-2.16 8.9a.94.94 0 100-1.87.94.94 0 000 1.87zm-5.43 7.55a5.68 5.68 0 1111.35.01 5.68 5.68 0 01-11.35-.01zm1.87 0a3.8 3.8 0 107.6-.01 3.8 3.8 0 00-7.6 0zm5.16-.94h-.42v-.98a.94.94 0 00-1.88 0v1.92c0 .52.42.94.94.94h1.36a.94.94 0 100-1.88zm-4.74-7.55a.94.94 0 11-1.87 0 .94.94 0 011.87 0zm-5.01 5.02a.94.94 0 100-1.88.94.94 0 000 1.88zM6.8 9.84a.94.94 0 11-1.88 0 .94.94 0 011.88 0zm-.94 5.02a.94.94 0 100-1.88.94.94 0 000 1.88zM6.8 18a.94.94 0 11-1.88 0 .94.94 0 011.88 0zm3.14.94a.94.94 0 100-1.88.94.94 0 000 1.88zm.94-9.1a.94.94 0 11-1.88 0 .94.94 0 011.88 0z" :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#EE733A',
    },
  },
};
</script>
